export default __webpack_public_path__ + "0c4abd7a144fdbc8d1cd5d7c5b0ccc0b.svg";